enum theme {
  primary = 'rgba(var(--primary-main-rgb),0.3)',
  secondary = 'rgba(var(--secondary-main-rgb),0.3)',
  tertiary = 'rgba(var(--tertiary-main-rgb),0.3)',
  error = 'rgba(var(--error-main-rgb),0.3)',
  success = 'rgba(var(--success-main-rgb),0.3)',
  warning = 'rgba(var(--warning-main-rgb),0.3)',
  info = 'rgba(var(--info-main-rgb),0.3)',
}

export function gradientStyle(input?: string | null | undefined) {
  if (!input) return { background: 'transparent' };
  const [topRaw, bottomRaw] = input.split(':');

  const resolveColor = (raw?: string): string => {
    if (!raw) return 'transparent';
    const lower = raw.toLowerCase();
    if (lower in theme) {
      return theme[lower as keyof typeof theme];
    }
    return raw; // assume it's already valid CSS color
  };

  const top = resolveColor(topRaw);
  const bottom = resolveColor(bottomRaw);

  return {
    backgroundImage: `linear-gradient(to bottom, ${top}, ${bottom})`,
  };
}
